import { useContext } from 'react';
import { Button, Grid, Modal, Typography } from '@mui/material';
import { WizardContext } from '../../wizard/Context';
import { useMutation, useQueryClient } from 'react-query';
import { deleteChat } from '../../../services/Chat';
import { useToast } from '../../toast';
import { set } from 'date-fns';

const DeleteModal = ({ open, setOpen, chatId }) => {
    const { state, dispatch } = useContext(WizardContext);
    const { addToast } = useToast();
    const { chatConfig } = state;
    const queryClient = useQueryClient();
    const { mutate, isLoading } = useMutation(
        deleteChat,
        {
            onSuccess: () => {
                queryClient.invalidateQueries("getChats");

                addToast({
                    type: "success",
                    message: `Chat deleted successfully.`,
                    autoClose: 2000,
                });

                if (chatConfig?.chatId === chatId) {
                    dispatch({
                        type: "UPDATE_CHAT_WINDOW",
                        payload: {
                            chatConfig: {
                                initiated: true,
                            },
                        },
                    });
                }

                setOpen(false);
            },

            onError: (error) => {
                addToast({
                    type: "error",
                    message: `Failed to delete chat: ${error?.message || "Unknown error"}`,
                    autoClose: 2000,
                });

                setOpen(false);
            }
        }
    );

    const handleDelete = () => {
        mutate({
            chatId,
        })
    };

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="delete-chat-modal"
            aria-describedby="delete-chat-description"
        >
            <Grid
                sx={{
                    position: 'absolute',
                    padding: "30px",
                    display: 'flex',
                    flexDirection: 'column',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '500px',
                    bgcolor: 'background.paper',
                    borderRadius: "10px",
                    gap: '20px',
                }}
            >
                <Typography>Are you sure you want to delete this chat?</Typography>
                <Grid
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '10px',
                    }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={isLoading}
                        onClick={handleDelete}
                    >
                        {isLoading ? "Deleting..." : "Delete"}
                    </Button>
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => setOpen(false)}
                    >
                        Cancel
                    </Button>
                </Grid>
            </Grid>
        </Modal>
    )
}

export default DeleteModal;
